import {
  Box,
  Container,
  Typography
} from '@mui/material';


const HeroUnder = ({title, description, estimate = true}) => {

  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        mt: {
          xs: '-80px',
          md: '-120px'
        },
        pt: {
          xs: '120px',
          md: '260px'
        },
        pb: {
          xs: '120px',
          md: '160px'
        },
        backgroundImage: { md: 'url("/img/estimate-bg.jpg")' },
        backgroundPosition: { md: 'center' },
        backgroundRepeat: { md: 'no-repeat' },
        backgroundSize: { md: 'cover' },
      }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            alignItems: {
              xs: 'center',
              md: 'flex-start'
            },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: 'white',
          }}
        >
          <Box display={{xs: "none", md: "block"}}>
            <Typography variant="h3" component="h1" gutterBottom>
              {title} {estimate && <Box component="span" color="secondary.main">Cost Estimate</Box>}
            </Typography>
            <Typography variant="h5" component="h2">
              {description}
            </Typography>
          </Box>
          <Box textAlign="center" display={{xs: "block", md: "none"}}>
            <Typography variant="h4" component="h1" gutterBottom>
              {title} {estimate && <Box component="span" color="secondary.main">Cost Estimate</Box>}
            </Typography>
            <Typography variant="subtitle1" component="h3">
              {description}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default HeroUnder;
